import React from 'react'
import { Row, Field } from 'react-gridforms'
import Input from 'bisu-react-input'

const FieldGroupRow = ({ ...props }) => (
  <Row>
    <Field>
      <Input {...props} />
    </Field>
  </Row>
)

export default FieldGroupRow



// WEBPACK FOOTER //
// ./src/components/FieldGroupRow/index.js